module.exports = __webpack_public_path__ + "img/sousuo@2x.d6e36731.png";